import { RelayApi } from 'api/ApiHelper';
import { relayQueryKey } from 'queries/relay/queryKey';
import { useQuery } from '@tanstack/react-query';

export const usePostRelayProfilesQuery = (profileIds: number[]) =>
  useQuery({ queryKey: relayQueryKey.profileList(profileIds), queryFn: () => RelayApi.profiles({ profileIds }) });
